module.exports = __webpack_public_path__ + "img/chart_01.378babf8.png";